import { render } from "./SummaryTable.vue?vue&type=template&id=4ceda4d4&ts=true"
import script from "./SummaryTable.vue?vue&type=script&lang=ts"
export * from "./SummaryTable.vue?vue&type=script&lang=ts"

import "./SummaryTable.vue?vue&type=style&index=0&id=4ceda4d4&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__